<template>
    <div>
        <h3>跟进记录</h3>
        <el-form :inline="true" class="demo-form-inline" size="mini">
            <!-- <el-form-item label="职位id">
                <el-input placeholder="输入职位id" v-model="filter.jobId"></el-input>
            </el-form-item> -->
            <el-form-item label="用户id">
                <el-input placeholder="输入用户id" v-model.number="filter.userId"></el-input>
            </el-form-item>
            <el-form-item label="手机号">
                <el-input placeholder="输入手机号" v-model="filter.phoneNum"></el-input>
            </el-form-item>
            <el-form-item label="跟进人">
                <el-input placeholder="输入跟进人" v-model="filter.founder"></el-input>
            </el-form-item>
            </el-form-item>
            <el-form-item label="跟进时间从">
                <el-date-picker v-model="filter.folBeginTime" type="datetime" placeholder="开始时间" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss">
                </el-date-picker>
            </el-form-item>
            <el-form-item label="到">
                <el-date-picker v-model="filter.folEndTime" type="datetime" placeholder="结束时间" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss">
                </el-date-picker>
            </el-form-item>
            <el-form-item label="下次跟进时间从">
                <el-date-picker v-model="filter.nextBeginTime" type="datetime" placeholder="开始时间" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss">
                </el-date-picker>
            </el-form-item>
            <el-form-item label="到">
                <el-date-picker v-model="filter.nextEndTime" type="datetime" placeholder="结束时间" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss">
                </el-date-picker>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" size="mini" @click="fetch(1)">查询</el-button>
                <el-button type="primary" size="mini" @click="exportExcel">导出</el-button>
            </el-form-item>
        </el-form>

        <el-table :data="list" size="mini" v-loading="loading">
            <el-table-column prop="userId" label="用户id">
                <template slot-scope="scope">
                    <a :href="`/clients?uid=${scope.row.userId}`" target="_blank">{{scope.row.userId}}</a>
                </template>
            </el-table-column>
            <el-table-column prop="nickname" label="昵称"></el-table-column>
            <el-table-column prop="phoneNumber" label="手机号"></el-table-column>
            <el-table-column prop="jobInfoList" label="职位名称" width="200">
                <template slot-scope="scope">
                    <p v-for="item in scope.row.jobInfoList">
                        <a :href="`${frontUrl}/job/detail/${item.jobId}`" target="_blank">{{item.jobTitle}}</a>
                    </p>
                </template>
            </el-table-column>
            <el-table-column prop="followContent" label="跟进内容" width="500"></el-table-column>
            <el-table-column prop="updateTime" label="跟进时间"></el-table-column>
            <el-table-column prop="founder" label="跟进人"></el-table-column>
            <el-table-column prop="nextFollowTime" label="下次跟进时间"></el-table-column>
            <el-table-column label="操作">
                <template slot-scope="scope">
                    <a :href="`/follow/detail?id=${scope.row.id}&from=follows`" target="_blank">编辑</a>
                </template>
            </el-table-column>
        </el-table>
        <br/>
        <div>
            <el-pagination background layout="prev, pager, next" :current-page="pageNum" @current-change="i=>pageNum=i" :page-size="limit" :total="total">
            </el-pagination>
        </div>
    </div>
</template>
<script>
import map from '../../datamap'

import api from '../api'
let {
    client
} = api
export default {
    name: 'user-list',
    data() {
        return {
            map,
            filter: {
                jobId: '',
                userId: '',
                folBeginTime: '',
                folEndTime: '',
                nextBeginTime: '',
                nextEndTime: '',
                founder: '',
                phoneNum: '',
            },
            loading: true,
            list: [],
            total: 0,
            pageNum: 1,
            limit: 20,
        }
    },
    computed: {
        userId() {
            return this.$route.query.userId;
        },
        jobId() {
            return this.$route.query.jobId;
        },
    },
    watch: {
        pageNum() {
            this.fetch()
        }
    },
    created() {
        if (this.userId) this.filter.userId = Number(this.userId);
        if (this.jobId) this.filter.jobId = this.jobId;
    },
    methods: {
        async fetch(num) {
            if (num == 1) {
                this.pageNum = 1;
            }

            let {
                jobId,
                userId,
                folBeginTime,
                folEndTime,
                nextBeginTime,
                nextEndTime,
                founder,
                phoneNum,
            } = this.filter;
            this.loading = true;
            let {
                data: {
                    data,
                    code,
                    desc,
                    pageinfo,
                }
            } = await client.follows({
                pageNum: this.pageNum,
                limit: this.limit,
                jobId,
                userId: Number.isInteger(userId) ? userId : '',
                folBeginTime,
                folEndTime,
                nextBeginTime,
                nextEndTime,
                founder,
                phoneNum,
            })
            if (code == 200) {
                this.list = data;
                this.total = pageinfo.totalCount;
            }
            this.loading = false;
        },
        async exportExcel() {
            this.loading = true

            let resp = await client.exportFollows(this.filter)
            let objectUrl = URL.createObjectURL(new Blob([resp.data]))
            let link = document.createElement('a')
            link.download = decodeURIComponent('跟进记录表.xlsx')
            link.href = objectUrl
            link.click()
            this.loading = false
        },
    },
    mounted() {
        this.fetch()
    }
}
</script>
<style>
</style>


// WEBPACK FOOTER //
// src/views/client/follows.vue